module.exports = __webpack_public_path__ + "img/parking.c62e03ed.svg";